<template>
  <div class="article-swiper swiper-element" v-if="swiperArticles">
    <swiper
      :slidesPerView="1"
      :spaceBetween="20"
      :breakpoints="{
      '640': {
        slidesPerView: 1.6,
        spaceBetween: 20,
      },
      '768': {
        slidesPerView: 1,
        spaceBetween: 20,
      },      
    }"      
      :centeredSlides="false"
      :grabCursor="true"
      :pagination="{
        bullets: true,
      }"
      :style="{
        '--swiper-navigation-color': '#07034A',
        '--swiper-pagination-color': '#FFFFFF',
      }"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
      @afterInit="onSlideInit"
      :lazy="true"
      class="knd-swiper"
    >
      <swiper-slide
        class="knd-article__slide"
        v-for="(article, index) in swiperArticles"
        :class="{ 'knd-slide__even': index % 2 === 0 }"
        :key="index + '-article'"
      >
        <article class="knd-article" @click="gotoProject(article['url'])">
          <div class="knd-article--image">
            <img :src="`${assetsUrl}${article.image.data.attributes.formats.small.url}`" alt="" />
          </div>
          <div class="knd-article__content knd-article__content_padding">
            <div class="knd-article--title">
              {{ article['title'] }}
            </div>
          </div>
        </article>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Lazy, Pagination } from "swiper";
import { mapGetters } from "vuex";

SwiperCore.use([Pagination, Lazy]);

import "./articleswiper.scss";

export default {
  name: "ArticleSwiper",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      selected: undefined,
      assetsUrl: process.env.VUE_APP_ASSETS,
    };
  },
  computed: {
    ...mapGetters(["swiperArticles"])
  },
  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {},
    onSlideInit() {},

    gotoProject(url) {
      window.open(url);
    },
  },
};
</script>
